import React, { useEffect, useState } from 'react'
import INCSUBButton from '../../../components/common/Button/INCSUBButton';
import "./styleComplaintsDetails.css"
import { toast } from 'react-toastify';
import { getComplaintChats, getComplaintDetails, updateComplaintChat, updateComplaintStatus, updateRefund } from '../../../services/complaintServices';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ImageIcon, Paperclip, Send } from 'lucide-react';
import { setComplaintList, setComplaintRoute } from '../../../features/complaints/complaintsSlice';
import INCSUBPoolDetails from '../../pools/poolDetails';
import { setPoolDetails, setSelectedPool } from '../../../features/pools/poolsSlice';

function INCSUBComplaintsDetails() {
    const navigate = useNavigate()
    const selectedComplaint = useSelector((state) => state.complaint.selectedComplaint);
    const [complaintDetails, setComplaintDetails] = useState(null);
    const [complaintChat, setComplaintChat] = useState(null);
    const [chatShimmer, setChatShimmer] = useState(false);
    const [groupChatRoomId, setGroupChatRoomId] = useState(false);
    const [contactPopup, setContactPopup] = useState();
    const [refundPopup, setRefundPopup] = useState(false);
    const [refundSucessPopup, setRefundSucessPopup] = useState(false);
    const [refundLoader, setRefundLoader] = useState(false);
    const dispatch = useDispatch();
    const complaintList = useSelector((state) => state.complaint.complaintList);
    const complaintRoute = useSelector((state) => state.complaint.complaintRoute);
    const [loader, setLoader] = useState(false);
    const [refundTextError, setRefundTextError] = useState(false)
    const [refundAmmount, setRefundAmount] = useState(selectedComplaint.refundAmount)

    const fetchComplaintChat = async (complaintId) => {

        const userId = JSON.parse(window.localStorage.getItem('userData')).userId
        try {
            const chat = await getComplaintChats(complaintId, userId);
            if (chat.status === 200) {
                setGroupChatRoomId(chat.data.data.groupChatRoomId)
                setComplaintChat(chat.data.data.chatsMessagesDtoList);
            } else if (chat.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(chat.status)) {
                toast.error(chat.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }
    }
    const fetchComplaintDetails = async (complaint) => {
        setLoader(true)
        dispatch(setSelectedPool(null))
        try {
            const detailsData = await getComplaintDetails(complaint);
            if (detailsData.status === 200) {
                setComplaintDetails(detailsData.data.data);
                fetchComplaintChat(detailsData.data.data.complaintId);
                setRefundAmount(detailsData.data.data.refundAmount);
                if (detailsData.data.data.poolId) {
                    dispatch(setSelectedPool({ poolId: detailsData.data.data.poolId }))
                } else {
                    dispatch(setSelectedPool(null));
                    dispatch(setPoolDetails(null))
                }

            } else if (detailsData.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (detailsData.status === 404) {
                dispatch(setComplaintRoute('/complaints'));
                toast.warning("This Complaint is not available")
            } else if (![200, 401].includes(detailsData.status)) {
                toast.error(detailsData.data.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        } finally {
            setLoader(false)
        }
    }
    useEffect(() => {
        if (selectedComplaint) {
            fetchComplaintDetails(selectedComplaint);

        }
    }, [selectedComplaint])

    const [message, setMessage] = useState({
        messageId: "",
        messageType: "manual",
        chatMessage: "",
        messageSentAt: "",
        senderName: "",
        senderId: "",
        senderImage: "",
        clickable: false,
        clicked: false,
        bySystem: false
    });
    const [sendBtnDisable, setSendBtnDisable] = useState()
    const handleReplyOnChat = async (groupChatRoomId, chatMessage) => {
        setSendBtnDisable(true);
        const userData = JSON.parse(window.localStorage.getItem('userData'));

        setMessage((prev) => ({
            ...prev,
            chatMessage: chatMessage,
            messageSentAt: formatDateTime(new Date()),
            senderName: userData.userFullName,
            senderId: userData.userId,
            senderImage: userData.userImage,
            senderType: userData.userType
        }))

        try {
            const replyData = await updateComplaintChat(groupChatRoomId, userData.userId, chatMessage);
            if (replyData.status === 200) {
                const updatedChat = [...complaintChat, {
                    chatMessage: chatMessage,
                    messageSentAt: formatDateTime(new Date()),
                    senderName: userData.userFullName,
                    senderId: userData.userId,
                    senderImage: userData.userImage,
                    senderType: userData.userType
                }]
                setComplaintChat(updatedChat);
                setMessage((prev) => ({
                    ...prev,
                    chatMessage: '',
                }))
            } else if (replyData.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(replyData.status)) {
                toast.error(replyData.data.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        } finally {
            setSendBtnDisable(false)
        }

    }

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

        return `${formattedDate} ${formattedTime}`;
    };

    /*
    Below variables and functions is for attachments and send messages
    
    */

    const [attachments, setAttachments] = useState([]);

    const handleReplySend = () => {
        if (message.chatMessage.trim() || attachments.length > 0) {
            handleReplyOnChat(groupChatRoomId, message.chatMessage);
            // setMessage("");
            setAttachments([]);
        } else {
            toast.error('Please write a message before send ')
        }
    };


    const removeAttachment = (index) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };


    /*updating a complaint status*/
    const handleComplaintStatus = async (e) => {
        const userId = JSON.parse(window.localStorage.getItem('userData')).userId;
        const complaintId = complaintDetails.complaintId;
        const complaintStatus = 'close'
        try {
            const complaintData = await updateComplaintStatus(complaintId, complaintStatus, userId);
            if (complaintData.status === 200) {
                setComplaintDetails((prev) => ({
                    ...prev,
                    complaintStatus: 'Close'
                }))
                const updatedData = complaintList && complaintList.complaintsDetailsDtoList.map((complaint) => complaintId === complaint.complaintId ? {
                    ...complaintDetails,
                    complaintStatus: 'Close',
                    complaintClosingDate: new Date()
                } : complaint)
                dispatch(setComplaintList({
                    ...complaintList,
                    complaintsDetailsDtoList: updatedData,

                }))
            } else if (complaintData.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(complaintData.status)) {
                toast.error(complaintData.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        }
    }

    const handleRefundStatus = async () => {
        setRefundLoader(true)
        const complaintId = complaintDetails.complaintId;
        const userId = complaintDetails?.complaintSubmittedFromId;
        const amount = complaintDetails.refundAmount
        if (amount === '' || amount === 0) {
            toast.warning("Please enter valid refund ammount");
            setRefundLoader(false)
            return 0
        }
        try {
            const complaintData = await updateRefund(complaintId, amount, userId);
            if (complaintData.status === 200) {
                setRefundLoader(false);
                setRefundSucessPopup(true);
                setRefundPopup(false)
                setComplaintDetails((prev) => ({
                    ...prev,
                    complaintStatus: 'Close'
                }))
                const updatedData = complaintList && complaintList.complaintsDetailsDtoList.map((complaint) => complaintId === complaint.complaintId ? {
                    ...complaintDetails,
                    complaintStatus: 'Close',
                    complaintClosingDate: new Date()
                } : complaint)
                dispatch(setComplaintList({
                    ...complaintList,
                    complaintsDetailsDtoList: updatedData,

                }))
                setTimeout(() => {
                    setRefundSucessPopup(false);
                }, 1500);

            } else if (complaintData.status === 401) {
                navigate('/login');
                window.localStorage.setItem('userData', null);
            } else if (![200, 401].includes(complaintData.status)) {
                toast.error(complaintData.data.message);
            }
        } catch (error) {
            toast.error("Something Went Wrong");
        } finally {
            setRefundLoader(false);
        }
    }

    const handleRefundPopup = () => {
        setRefundPopup(true)
    }
    const handlePoolDetails = () => {
        dispatch(setComplaintRoute('/complaints/complainDetails/poolDetails'));

    }


    return (
        <>{complaintRoute === '/complaints/complainDetails' ? <div className="INCSUBPoolDetails_path">
            <div className='INCSUBPoolDetails_filter_section_path_btn'><svg onClick={() => {
                dispatch(setComplaintRoute('/complaints'));
            }} className='back_arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>{<p>{'Complaints/ '}</p>}
                <h1>{"details"}</h1>
            </div>

        </div> : null}
            {complaintRoute === "/complaints/complainDetails" ? <div className='INCSUBComplaintsDetails'>

                {!loader ? <div className='INCSUBComplaintsDetails_container'>

                    <div className='INCSUBComplaintDetails_main'>
                        <div className='INCSUBComplaintDetails_header_container'>
                            <div className='INCSUBComplaints_header_text_feilds'>
                                <div className='INCSUBComplaints_header_head'>{complaintDetails?.complaintTitle}<span>{complaintDetails?.complaintType}</span></div>
                                <div className='INCSUBComplaints_submitted_date'>Submitted: <span>{complaintDetails?.complaintSubmittedDate}</span></div>
                            </div>
                            <div className='INCSUBComplaints_buttons_container'>
                                {complaintDetails?.poolId ? <INCSUBButton text='Go to Pool' clickFun={handlePoolDetails} /> : null}
                                {(complaintDetails?.complaintType === 'RequestRefund' || complaintDetails?.complaintType === 'PoolRefund') && complaintDetails?.complaintStatus !== 'Close' ? <INCSUBButton text='Refund' marginRight={'55px'} clickFun={handleRefundPopup} /> : null}
                                {/* <INCSUBButton text='contact to member' border="1px solid #4880FF" color={'rgba(32, 34, 36, 0.65)'} background='#ffffff' /> */}
                                <div className='INCSUBComplaints_button' onClick={() => {
                                    setContactPopup(true);
                                }}><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.3332 13.0975V15.5975C17.3341 15.8296 17.2866 16.0593 17.1936 16.2719C17.1006 16.4846 16.9643 16.6755 16.7933 16.8324C16.6222 16.9893 16.4203 17.1087 16.2005 17.1831C15.9806 17.2574 15.7477 17.285 15.5165 17.2641C12.9522 16.9855 10.489 16.1093 8.32486 14.7058C6.31139 13.4264 4.60431 11.7193 3.32486 9.70581C1.91651 7.53181 1.04007 5.05664 0.76653 2.48081C0.745705 2.25037 0.773092 2.01811 0.846947 1.79883C0.920801 1.57955 1.03951 1.37805 1.1955 1.20716C1.3515 1.03627 1.54137 0.899734 1.75302 0.806245C1.96468 0.712755 2.19348 0.664361 2.42486 0.664143H4.92486C5.32928 0.660163 5.72136 0.803375 6.028 1.06709C6.33464 1.3308 6.53493 1.69702 6.59153 2.09748C6.69705 2.89753 6.89274 3.68308 7.17486 4.43914C7.28698 4.73741 7.31125 5.06157 7.24478 5.37321C7.17832 5.68485 7.02392 5.9709 6.79986 6.19748L5.74153 7.25581C6.92783 9.3421 8.65524 11.0695 10.7415 12.2558L11.7999 11.1975C12.0264 10.9734 12.3125 10.819 12.6241 10.7526C12.9358 10.6861 13.2599 10.7104 13.5582 10.8225C14.3143 11.1046 15.0998 11.3003 15.8999 11.4058C16.3047 11.4629 16.6744 11.6668 16.9386 11.9787C17.2029 12.2906 17.3433 12.6888 17.3332 13.0975Z" stroke="#4880FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Contact to member</div>
                                {complaintDetails?.complaintStatus !== 'Close' && complaintDetails?.complaintType !== 'Refund' ? <INCSUBButton text='Mark as close' clickFun={handleComplaintStatus} /> : (complaintDetails?.complaintType !== 'Refund' ? <INCSUBButton text='Closed' background={"rgba(32, 34, 36, 0.04)"} border={"0.6px solid rgba(32, 34, 36, 0.1)"} border-radius={"4px"} color='#202224' cursor={"default"} /> : null)}
                            </div>
                        </div>
                        <hr />

                        {groupChatRoomId ? <div className='INCSUBConversation_container'>
                            {
                                complaintChat && complaintChat.length > 0 && !chatShimmer && complaintChat.map((complaint) => <div className='INCSUBConversation_single_conversation'>
                                    <div className='INCSUBConversation_image_container'>
                                        <img src={complaint.senderImage ? complaint.senderImage : '/assets/icons/common/defaultImage.png'} alt='' />
                                    </div>
                                    <div className='INCSUBConversation_text_feilds_container'>
                                        <div className='INCSUBConversation_text_feilds_headings'>
                                            <div className='INCSUBConversation_heading_name_container'>
                                                <div className='INCSUBConversation_name'>{complaint.senderName}</div>
                                                <div className='INCSUBConversation_designation'>Member</div>
                                            </div>
                                            <div className='INCSUBConversation_time'>{formatDateTime(complaint.messageSentAt)}</div>
                                        </div>
                                        {/* <div className='INCSUBConversation_containt_heading'>Hello Sir,</div> */}
                                        <div className='INCSUBConversation_containt_text'>{complaint.chatMessage}</div>
                                    </div>
                                </div>)
                            }
                        </div> : (!loader ? <div className='INCSUBComplaint_message'>
                            <div className='INCSUBComplaint_message_heading'>Complaint Message:</div>
                            <div className='INCSUBComplaint_message_text'>{complaintDetails?.complaintMessage}</div>
                            <div className='INCSUBComplaint_message_note'>*Please contact user to resolve issue</div>

                        </div> : null)}

                        {groupChatRoomId && complaintDetails?.complaintStatus !== "Close" ? <div className='INCSUBComplaints_typing_section_container'>
                            <div className='INCSUBComplaints_white_shadow'></div>
                            <div className='INCSUBComplaints_textfeild_heading'>Reply</div>
                            <div className="reply-box">
                                {/* Text Area */}
                                <textarea
                                    className=""
                                    rows="1"
                                    placeholder="Write message"
                                    value={message.chatMessage} // Ensure 'message' has a 'chatMessage' property
                                    onChange={(e) =>
                                        setMessage((prev) => ({
                                            ...prev,
                                            chatMessage: e.target.value,
                                        }))
                                    }
                                />

                                {/* Attachment Preview */}
                                {attachments.length > 0 && (
                                    <div className="attachment-preview">
                                        {attachments.map((file, index) => (
                                            <div key={index} className="attachment-item">
                                                <span>{file.name}</span>
                                                <button onClick={() => removeAttachment(index)}>✕</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {/* Action Buttons */}
                                <div className="action-buttons">

                                    <button onClick={() => sendBtnDisable ? null : handleReplySend()} className="send-button">
                                        <Send size={20} />
                                    </button>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                </div> : <div className='INCSUBComplaint_loader_container'><div className='INCSUBComplaint_loader' /></div>}{
                    contactPopup ?
                        <div className='INCSUBComplaint_popup'>
                            <div className='INCSUBComplaint_popup_container'>
                                <svg className='cancel' onClick={() => setContactPopup(false)} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46318 1.47683C1.77048 1.16963 2.1872 0.997049 2.62172 0.997049C3.05624 0.997049 3.47296 1.16963 3.78026 1.47683L9.99574 7.69231L16.2112 1.47683C16.3624 1.32032 16.5432 1.19548 16.7431 1.1096C16.9431 1.02372 17.1581 0.978515 17.3757 0.976624C17.5932 0.974734 17.809 1.01619 18.0104 1.09859C18.2118 1.18098 18.3948 1.30266 18.5486 1.45652C18.7025 1.61038 18.8242 1.79334 18.9065 1.99473C18.9889 2.19611 19.0304 2.41189 19.0285 2.62947C19.0266 2.84706 18.9814 3.06208 18.8955 3.26201C18.8097 3.46193 18.6848 3.64275 18.5283 3.79391L12.3128 10.0094L18.5283 16.2249C18.8268 16.5339 18.992 16.9479 18.9882 17.3775C18.9845 17.8072 18.8122 18.2182 18.5083 18.522C18.2045 18.8258 17.7935 18.9982 17.3639 19.0019C16.9342 19.0056 16.5203 18.8405 16.2112 18.542L9.99574 12.3265L3.78026 18.542C3.4712 18.8405 3.05727 19.0056 2.62762 19.0019C2.19796 18.9982 1.78696 18.8258 1.48314 18.522C1.17932 18.2182 1.00698 17.8072 1.00325 17.3775C0.999513 16.9479 1.16468 16.5339 1.46318 16.2249L7.67866 10.0094L1.46318 3.79391C1.15598 3.48661 0.983398 3.06989 0.983398 2.63537C0.983398 2.20085 1.15598 1.78413 1.46318 1.47683Z" fill="black" />
                                </svg>

                                <svg width="99" height="110" viewBox="0 0 99 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M87.5356 109.419H16.4131V0H87.5356C93.5537 0 98.4775 4.92387 98.4775 10.9419V98.4773C98.4775 104.495 93.5537 109.419 87.5356 109.419Z" fill="#AAC4FF" />
                                    <path d="M10.9419 0H16.4129V109.419H10.9419C4.92387 109.419 0 104.495 0 98.4773V10.9419C0 4.92387 4.92387 0 10.9419 0Z" fill="#4880FF" />
                                    <path d="M54.7095 54.7042C60.7526 54.7042 65.6514 49.8053 65.6514 43.7622C65.6514 37.7192 60.7526 32.8203 54.7095 32.8203C48.6664 32.8203 43.7676 37.7192 43.7676 43.7622C43.7676 49.8053 48.6664 54.7042 54.7095 54.7042Z" fill="#4880FF" />
                                    <path d="M73.8583 71.1216C73.8583 71.1216 68.6609 60.1797 54.7099 60.1797C40.7589 60.1797 35.5615 71.1216 35.5615 71.1216V76.5926H73.8583V71.1216Z" fill="#4880FF" />
                                </svg>
                                <hr className='splitter'></hr>
                                <div className='INCSUBMemberList_li'>
                                    <div className='INCSUBmemberInfo_container'>
                                        <img src={complaintDetails?.complaintSubmittedFromImage ? complaintDetails?.complaintSubmittedFromImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                        <p>{complaintDetails?.complaintSubmittedFrom}</p>
                                    </div>
                                    <div className='INCSUBRefundRupees'>{complaintDetails?.mobileNumber}</div>
                                </div>
                            </div>
                        </div> : null
                }
                {
                    refundPopup ? <div className='INCSUBComplaintRefund_popup'>{!refundLoader ? <div className='INCSUBCategory_ask_container'>
                        <div className='INCSUBCategory_permission_header'>
                            Refundable Amount(₹)
                        </div>
                        <input
                            type="text"
                            name="username"
                            placeholder="Type Here..."
                            style={{
                                border: refundTextError && complaintDetails?.refundAmount === '' ? '1px solid red' : undefined,
                            }}
                            value={complaintDetails?.refundAmount || ''}
                            onChange={(e) => {
                                const input = e.target.value;

                                // Allow only numeric values
                                if (/^\d*\.?\d*$/.test(input)) {
                                    const inputNumber = parseFloat(input, 10);
                                    console.log(refundAmmount)
                                    // Check if inputNumber is less than or equal to refundAmount
                                    if (input === '' || inputNumber <= refundAmmount) {
                                        setComplaintDetails({
                                            ...complaintDetails,
                                            refundAmount: input,
                                        });
                                    }
                                }
                            }}
                        />

                        <div className='INCSUBCategory_permission_btn_container'>
                            <div className="INCSUBCategory_image_upload_btn">
                                <div className='INCSUBCategory_upload_btn' onClick={() => {
                                    handleRefundStatus()
                                }}>Yes, Refund</div>
                                <div className='upload_cancel_btn' onClick={() => setRefundPopup(false)}>No</div>
                            </div>
                        </div>
                    </div> : null}
                        {
                            refundLoader ? <div className='categoryloader' /> : null
                        }

                    </div> : (refundSucessPopup ? <div className='INCSUBComplaintRefund_popup'>
                        <div className='INCSUBCategory_ask' style={{ display: refundLoader ? 'none' : null }}>
                            <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                                <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                                <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                                <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                                <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                            </svg>


                            <div className='INCSUBCategory_permission_header'>
                                Refund has been completed successfully.
                            </div>


                        </div></div> : null
                    )
                }

            </div > : <INCSUBPoolDetails />}
        </>
    )
}

export default INCSUBComplaintsDetails
